import React from 'react'
import { ReactComponent as EmptyIcon } from 'assets/icons/empty.svg'
import s from '../../styles/AiToolContainer.module.scss'

export default function AiToolEmptyState({
	title = 'No results',
	text = 'Try a different category or sub-category.',
}) {
	return (
		<div className={s.finderEmpty} role="status">
			<EmptyIcon className={s.finderEmptyIcon} aria-hidden />
			<p className={s.finderEmptyTitle}>{title}</p>
			<p className={s.finderEmptyText}>{text}</p>
		</div>
	)
}
